import { add, qs, qsa } from '@fluorescent/dom';

import { section } from '@/neon';
import mobileCarousel from '@/lib/mobile-carousel';

const sel = {
  image: 'img',
  slider: '[data-slider]',
  slides: '[data-slide]',
};

section('testimonials', {
  onLoad() {
    const slider = qs(sel.slider, this.container);

    const slides = qsa(sel.slides, this.container);
    const images = qsa(sel.image, this.container);

    if (images.length !== slides.length) {
      add(this.container, 'testimonials--vertical');
      return;
    }

    this.mobileCarousel = mobileCarousel(slider);
  },

  onUnload() {
    this.mobileCarousel && this.mobileCarousel.destroy();
  },

  onBlockSelect({ target }) {
    this.mobileCarousel && this.mobileCarousel.select(target.dataset.index);
  },
});
